import React, { useState } from "react";
import Icon from "components/AppIcon";

const COLOMBIAN_CITIES = [
  "Bogotá D.C.", "Medellín", "Cali", "Barranquilla", "Cartagena de Indias",
  "Cúcuta", "Bucaramanga", "Pereira", "Santa Marta", "Ibagué",
  "Pasto", "Manizales", "Neiva", "Villavicencio", "Armenia",
  "Valledupar", "Montería", "Sincelejo", "Popayán", "Tunja",
  "Florencia", "Quibdó", "Riohacha", "San José del Guaviare", "Mocoa",
  "Mitú", "Puerto Carreño", "Inírida", "Leticia", "Yopal",
];

const CitySelect = ({ value, onChange, error }) => {
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);

  const filtered = COLOMBIAN_CITIES?.filter(c => c?.toLowerCase()?.includes(search?.toLowerCase()));

  const handleSelect = (city) => {
    onChange(city);
    setSearch("");
    setOpen(false);
  };

  return (
    <div className="relative">
      <label className="block text-sm font-medium mb-1" style={{ fontFamily: "var(--font-caption)", color: "var(--color-foreground)" }}>
        Ciudad
      </label>
      <div
        className="w-full px-3 py-2 rounded-md text-sm border flex items-center justify-between cursor-pointer transition-base"
        style={{
          background: "var(--color-card)",
          color: value ? "var(--color-foreground)" : "var(--color-muted-foreground)",
          borderColor: open ? "var(--color-primary)" : "var(--color-border)",
        }}
        onClick={() => setOpen(!open)}
        tabIndex={0}
        onKeyDown={(e) => { if (e?.key === "Enter" || e?.key === " ") setOpen(!open); }}
        role="combobox"
        aria-expanded={open}
      >
        <span>{value || "Seleccione una ciudad"}</span>
        <Icon name={open ? "ChevronUp" : "ChevronDown"} size={16} color="var(--color-muted-foreground)" />
      </div>
      {open && (
        <div
          className="absolute z-50 w-full mt-1 rounded-md shadow-elevation-3 overflow-hidden"
          style={{ background: "var(--color-card)", border: "1px solid var(--color-border)" }}
        >
          <div className="p-2 border-b" style={{ borderColor: "var(--color-border)" }}>
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e?.target?.value)}
              placeholder="Buscar ciudad..."
              className="w-full px-2 py-1 text-sm rounded"
              style={{ background: "var(--color-muted)", color: "var(--color-foreground)", border: "none", outline: "none", fontFamily: "var(--font-body)" }}
              autoFocus
            />
          </div>
          <div className="max-h-48 overflow-y-auto scrollbar-thin">
            {filtered?.length === 0 ? (
              <div className="px-3 py-2 text-sm" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
                No se encontraron ciudades
              </div>
            ) : filtered?.map((city) => (
              <div
                key={city}
                className="px-3 py-2 text-sm cursor-pointer transition-base"
                style={{
                  fontFamily: "var(--font-body)",
                  color: "var(--color-foreground)",
                  background: city === value ? "var(--color-primary)15" : "transparent",
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = "var(--color-muted)"}
                onMouseLeave={(e) => e.currentTarget.style.background = city === value ? "var(--color-primary)15" : "transparent"}
                onClick={() => handleSelect(city)}
              >
                {city}
              </div>
            ))}
          </div>
        </div>
      )}
      {error && <p className="text-xs mt-1" style={{ color: "var(--color-error)", fontFamily: "var(--font-caption)" }}>{error}</p>}
    </div>
  );
};

export default CitySelect;